// A stable per browser id stands in for the hardware device id.
function uniqueId() {
  const key = "@TailPOS:webDeviceId";
  try {
    let id = window.localStorage.getItem(key);
    if (!id) {
      id =
        "web-" +
        Math.random()
          .toString(36)
          .slice(2, 10) +
        Date.now().toString(36);
      window.localStorage.setItem(key, id);
    }
    return id;
  } catch (e) {
    return "web-browser";
  }
}

export default {
  getDeviceId: uniqueId,
  getUniqueID: uniqueId,
  getDeviceName: () => "Web Browser",
  getModel: () => "Web",
  getBrand: () => "Browser",
  getSystemName: () => "Web",
  getSystemVersion: () => navigator.userAgent,
  getVersion: () => "1.4.0",
  getBuildNumber: () => "1",
  isTablet: () => true,
  isEmulator: () => false,
};
